import ModalInvite from './ModalInvite';

export default ModalInvite;
